<template>
	<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
		<div class="row hideMobile">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 tableOverflow">
				<div class="listHeader">
					<div class="row">
						<div class="col-xs-12 col-sm-3 col-lg-2">
							<p class="cursor-pointer" @click="sortBy('id')">
								User <span :class="getSortIcon('id')" class="ml-1"></span>
							</p>
						</div>
						<div
							v-if="tenants.length > 1 || $global.hasUserRole(userRoles, 'reseller')"
							class="col-xs-12 col-sm-3 col-lg-2"
						>
							<p class="cursor-pointer" @click="sortBy('tenant')">
								Tenant <span :class="getSortIcon('tenant')" class="ml-1"></span>
							</p>
						</div>
						<div class="col-xs-12 col-sm-2 hideTabletLandscape">
							<p class="cursor-pointer" @click="sortBy('account')">
								Account <span :class="getSortIcon('account')" class="ml-1"></span>
							</p>
						</div>
						<div class="col-xs-12 col-sm-6 col-lg-2">
							<p class="cursor-pointer" @click="sortBy('expires')">
								Expires <span :class="getSortIcon('expires')" class="ml-1"></span>
							</p>
						</div>
						<div class="col-xs-12 col-sm-2 hideTabletLandscape">
							<p class="cursor-pointer" @click="sortBy('iccid')">
								ICCID <span :class="getSortIcon('iccid')" class="ml-1"></span>
							</p>
						</div>
						<div class="col-xs-12 col-sm-2 hideTabletLandscape">
							<p class="cursor-pointer" @click="sortBy('description')">
								Description <span :class="getSortIcon('description')" class="ml-1"></span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-for="reg in sortedRegistrations" :key="reg.id" class="card listItem">
			<div class="row content middle-sm middle-md middle-lg">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
					<div class="row middle-sm middle-md middle-lg tableOverflow">
						<div class="col-xs-12 col-sm-3 col-lg-2">
							<span class="block text-xs font-semibold uppercase text-[#999999] sm:hidden">User: </span>
							<p
								class="mb-4 overflow-hidden text-ellipsis sm:mb-0"
								@mouseover="createTooltip($event, reg.id)"
							>
								{{ reg.mobileSim?.number || reg.id }}
							</p>
						</div>
						<div
							v-if="tenants.length > 1 || $global.hasUserRole(userRoles, 'reseller')"
							class="col-xs-12 col-sm-3 col-lg-2"
						>
							<span class="block text-xs font-semibold uppercase text-[#999999] sm:hidden">Tenant: </span>
							<p
								class="mb-4 overflow-hidden text-ellipsis sm:mb-0"
								@mouseover="createTooltip($event, reg.tenant?.companyName || 'Unknown')"
							>
								{{ reg.tenant?.companyName || 'Unknown' }}
							</p>
						</div>
						<div class="col-xs-12 col-sm-2 hideTabletLandscape">
							<span class="block text-xs font-semibold uppercase text-[#999999] sm:hidden"
								>Account:
							</span>
							<p
								class="mb-4 overflow-hidden text-ellipsis sm:mb-0"
								@mouseover="createTooltip($event, reg.account?.name || 'Unknown')"
							>
								{{ reg.account?.name || 'Unknown' }}
							</p>
						</div>
						<div class="col-xs-12 col-sm-6 col-lg-2">
							<span class="block text-xs font-semibold uppercase text-[#999999] sm:hidden"
								>Expires:
							</span>
							<p
								class="mb-4 overflow-hidden text-ellipsis sm:mb-0"
								@mouseover="
									createTooltip($event, $global.dateTimeFormat(reg.expires)) +
									'(' +
									timeRemaining(reg.expires) +
									')s'
								"
							>
								{{ $global.dateTimeFormat(reg.expires) }} ({{ timeRemaining(reg.expires) }}s)
							</p>
						</div>
						<div class="col-xs-12 col-sm-2 hideTabletLandscape">
							<span class="block text-xs font-semibold uppercase text-[#999999] sm:hidden">ICCID: </span>
							<p class="mb-4 overflow-hidden text-ellipsis sm:mb-0">
								{{ reg.mobileSim?.iccid || 'Unknown' }}
							</p>
						</div>
						<div class="col-xs-12 col-sm-2 hideTabletLandscape">
							<span class="block text-xs font-semibold uppercase text-[#999999] sm:hidden"
								>Description:
							</span>
							<p class="mb-4 overflow-hidden text-ellipsis sm:mb-0">
								{{ reg.mobileSim?.description || 'No description' }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="!registrations || !registrations.length" class="card no-action listItem orange">
			<div class="row content middle-sm middle-md middle-lg">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
					<div class="row middle-sm middle-md middle-lg">
						<div class="col-xs-12">
							<p>No mobile SIMs found.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { router } from '../router'

export default {
	inject: ['user', 'userRoles', 'tenants'],
	props: ['registrations'],

	data() {
		return {
			sortField: 'id',
			sortDirection: 'asc'
		}
	},

	computed: {
		sortedRegistrations() {
			return [...this.registrations].sort((a, b) => {
				let comparison = 0
				switch (this.sortField) {
					case 'id':
						comparison = (a.mobileSim?.number || a.id).localeCompare(b.mobileSim?.number || b.id)
						break
					case 'tenant':
						comparison = (a.tenant?.companyName || '').localeCompare(b.tenant?.companyName || '')
						break
					case 'account':
						comparison = (a.account?.name || '').localeCompare(b.account?.name || '')
						break
					case 'expires':
						comparison = new Date(a.expires) - new Date(b.expires)
						break
					case 'iccid':
						comparison = (a.mobileSim?.iccid || '').localeCompare(b.mobileSim?.iccid || '')
						break
					case 'description':
						comparison = (a.mobileSim?.description || '').localeCompare(b.mobileSim?.description || '')
						break
				}
				return this.sortDirection === 'asc' ? comparison : -comparison
			})
		}
	},

	methods: {
		routeTo(routeName) {
			router.push(routeName)
		},
		timeRemaining(expires) {
			const now = new Date()
			const expiresDate = new Date(expires)
			const diff = expiresDate - now
			return Math.round(diff / 1000)
		},
		sortBy(field) {
			if (this.sortField === field) {
				this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
			} else {
				this.sortField = field
				this.sortDirection = 'asc'
			}
		},
		getSortIcon(field) {
			if (this.sortField !== field) return ''
			return this.sortDirection === 'asc' ? 'fa-light fa-chevron-up' : 'fa-light fa-chevron-down'
		}
	}
}
</script>
